import React, {Component} from 'react';
import './BaseUrgencyMessage.less';
import {SMALL, MEDIUM} from '../../helpers/IconSize';

export default class BaseUrgencyMessage extends Component {
    static defaultProps = {
        className: '',
        size: MEDIUM,
        unitMessage: {},
        color: false,
        ariaHidden: false
    };

    generateComponent = ({className, style, src, icon, message, size, ariaHidden}) => {
        return (
            <div className={`UrgencyMessage ${className}`} aria-hidden={ariaHidden}>
                <div className={`UrgencyMessage__img--${size}`}>
                    <img style={style} src={src} alt={icon} />
                </div>
                <span className={`UrgencyMessage__text${size === SMALL ? '--s' : ''}`}>
                    {message}
                </span>
            </div>
        );
    };
}
